import type { FileTreeEntry } from '@localagent/ui';

export function mergeKnownEntries(
  prev: FileTreeEntry[],
  entries: FileTreeEntry[],
): FileTreeEntry[] {
  const map = new Map(prev.map((e) => [e.path, e]));
  let changed = false;
  for (const e of entries) {
    const existing = map.get(e.path);
    if (!existing || existing.isDir !== e.isDir) {
      map.set(e.path, e);
      changed = true;
    }
  }
  return changed ? [...map.values()] : prev;
}
